import React from 'react';

const CARDS = [
  {
    title: 'You understand English, but speaking feels hard',
    body: 'Practice what to say before the real moment.',
  },
  {
    title: 'You need practical phrases, not grammar lectures',
    body: 'Learn lines you can actually use today.',
  },
  {
    title: 'You want short practice, not long lessons',
    body: 'Open the app, practice a situation, move on.',
  },
];

export default function WhoFor() {
  return (
    <section className="section section--muted">
      <h2 className="section__title">Made for people who know some English but freeze in real life</h2>
      <div className="whofor-grid">
        {CARDS.map((c) => (
          <div className="whofor-card" key={c.title}>
            <h3>{c.title}</h3>
            <p>{c.body}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
